import {
  type FC
} from 'react';
import {
  Box,
  Stack,
} from '@mui/joy';
import {
  CoinImage
} from '@shared/ui';
import {
  CurrencyCodesEnum
} from '@shared/types';
import {
  RewardInfoText
} from './reward-info-text.component';

export type RewardInfoProps = {
  redeemableCoinAmount: Maybe<number>;
  nonRedeemableCoinAmount: Maybe<number>;
};

export const RewardInfo: FC<RewardInfoProps> = ({
  nonRedeemableCoinAmount,
  redeemableCoinAmount
}) => (
  <Stack
    direction='row'
    sx={({ breakpoints }) => ({
      gap: 1,
      [breakpoints.down(1024)]: { gap: 0.5 }
    })}>
    {nonRedeemableCoinAmount && (
      <Stack
        gap={0.1}
        direction='row'
        alignItems='center'>
        <CoinImage
          code={CurrencyCodesEnum.GCO}
          sx={{ height: 12, width: 12 }}
        />
        <RewardInfoText rewardAmount={nonRedeemableCoinAmount} />
      </Stack>
    )}
    {redeemableCoinAmount && (
      <Stack
        gap={0.1}
        direction='row'
        alignItems='center'>
        <CoinImage
          code={CurrencyCodesEnum.SCO}
          sx={{ height: 12, width: 12 }}
        />
        <RewardInfoText
          rewardAmount={redeemableCoinAmount}
          postfixSlot={
            <Box
              component='span'
              sx={({ palette }) => ({
                color: palette.common[825],
              })}>
              &nbsp;FREE SC
            </Box>
          }
        />
      </Stack>
    )}
  </Stack>
);
